export interface DataType {
  name: string;
  byteSize: number | 'variable';
  description: string;
}

export interface DataItem {
  name: string;
  type: string;
  length?: number | string;
  description: string;
  required: boolean;
}

export interface DataItemCode {
  value: string;
  meaning: string;
}

export interface DataItemDefinition {
  name: string;
  type: string;
  length?: string;
  description: string;
  usedIn?: string[];
  codes?: DataItemCode[];
  notes?: string[];
}

export interface MessageDataItemRef {
  ref: string;
  required?: boolean;
  length?: string;
  description?: string;
}

export type MessageDataItem = DataItem | MessageDataItemRef;

export interface GemStateModel {
  name: string;
  description: string;
  states: { name: string; description: string }[];
}

export interface GemCapability {
  name: string;
  description: string;
  messages: string[];
}

export interface GemData {
  stateModels: GemStateModel[];
  capabilities: GemCapability[];
}

export interface SecsMessage {
  id?: string;
  stream: number;
  function: number;
  name: string;
  direction: 'H->E' | 'E->H' | 'H<->E';
  messageType: 'primary' | 'secondary';
  relatedMessage?: string;
  reply?: string;  // For primary messages
  primary?: string; // For secondary messages
  format: string;
  structure?: string;
  dataItems: MessageDataItem[];
  description: string;
  usage?: string;
  notes?: string[];
}

export interface StreamFunction {
  [key: string]: SecsMessage;
}

export interface Stream {
  number: number;
  name: string;
  description: string;
  category: 'core' | 'optional' | 'gem' | 'custom';
  functions: StreamFunction;
}

export interface StreamData {
  [key: string]: Stream;
}

export interface SecsData {
  version: string;
  lastUpdated: string;
  dataTypes: {
    [key: string]: DataType;
  };
  dataItems?: {
    [key: string]: DataItemDefinition;
  };
  gem?: GemData;
  streams: StreamData;
}

export interface SearchResult {
  item: SecsMessage;
  score: number;
  matches?: Array<{
    key: string;
    value: string;
    indices: number[][];
  }>;
}

export interface AppState {
  selectedStream: string | null;
  selectedFunction: string | null;
  searchQuery: string;
  isDarkMode: boolean;
  recentlyViewed: string[];
  favorites: string[];
  sidebarCollapsed: boolean;
  sidebarWidth: number;
}

export function isDataItemRef(item: MessageDataItem): item is MessageDataItemRef {
  return (item as MessageDataItemRef).ref !== undefined;
}
